export default {
    createcourse:{},
    chapter: [],
    chapterlist : []
}